<template>
    <div>
        <v-toolbar
                :dense="true"
                :flat="true"
                color="transparent"
        >
            <v-spacer></v-spacer>
            <v-tooltip right bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon @click="visibleHiddenGroups = !visibleHiddenGroups" v-on="on">
                        <v-icon :color="visibleHiddenGroups ? 'success' : ''">remove_red_eye</v-icon>
                    </v-btn>
                </template>
                <span class="caption">Показать скрытые модули</span>
            </v-tooltip>
        </v-toolbar>
        <v-container ma-0 pa-0 px-4 class="container-with-horizontal-scroll" fluid>
                <v-row style="flex-wrap: nowrap">
                    <v-col cols="10" xs="8" sm="6" md="3" class="pa-1 ma-0"
                        v-for="(moduleGroup, indexGroup) in moduleGroups"
                        :key="moduleGroup.id"
                        v-show="moduleGroup.visible === 1 || visibleHiddenGroups"
                    >
                        <v-card class="blue-grey lighten-5 d-flex flex-column text-truncate"
                                :color="moduleGroup.visible === 1 ? 'blue-grey lighten-5' : 'blue-grey lighten-3'"
                        >
                            <v-card-title class="ml-2 pa-1">
                                <v-list-item-title class="bold subtitle-1" @click="editModuleGroup(indexGroup)" style="cursor: pointer;">
                                    {{moduleGroup.title}}
                                </v-list-item-title>
                            </v-card-title>
                            <module-group-list
                                    v-bind:style="[{height: (windowHeight - (moduleGroups.length > 3 ? 230 : 215)) + 'px'},{display: 'flex'},{'flex-direction': 'column'}]"
                                    :module-group-id="moduleGroup.id"
                                    :module-methods-loaded="moduleMethodsLoaded"
                            ></module-group-list>
                            <v-card-actions class="ma-0 pa-0">
                                <v-btn
                                        class="caption"
                                        block
                                        color="primary"
                                        text
                                        dark
                                        @click="showModuleSelectBlock(indexGroup)"
                                >Добавить модуль</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    <v-col cols="2" md6 offset-md="2" class="pa-1 ma-0">
                        <module-group-form
                                :editModuleGroupIndex="editModuleGroupIndex"
                                :dialog="dialog"
                                @close="dialog = false"
                        ></module-group-form>
                    </v-col>
                </v-row>
        </v-container>
        <module-select-block
                :mode="0"
                :moduleGroupIndex="moduleGroupIndex"
                :dialog="dialogModuleAdd"
                @close="dialogModuleAdd = false"
        ></module-select-block>
        <dialog-confirmation ref="confirm"></dialog-confirmation>
    </div>
</template>

<script>

import ModuleGroupForm from '../../components/bot/module/ModuleGroupForm'
import ModuleSelectBlock from '../../components/bot/module/ModuleSelectBlock'
import DialogConfirmation from '../../components/dialogs/DialogConfirmation'
import ModuleGroupList from '../../components/bot/module/ModuleGroupList'
import { mapGetters } from 'vuex'

export default {
    name: 'Index',
    components: {
        ModuleGroupForm,
        DialogConfirmation,
        ModuleSelectBlock,
        ModuleGroupList
    },
    data() {
        return {
            moduleGroupIndex: null,
            dialog: false,
            dialogModuleAdd: false,
            moduleMethodsLoaded: false,
            isDragging: false,
            changeModuleGroups: null,
            editModuleGroupIndex: null,
            visibleHiddenGroups: false,
            windowHeight: 0
        }
    },
    watch: {
        dialogModuleAdd(value) {
            if (value === false) {
                this.moduleGroupIndex = null
            }
        },
        dialog(value) {
            if (value === false) {
                this.editModuleGroupIndex = null
            }
        }
    },
    methods: {
        async removeModel(indexes) {
            this.$refs.confirm.open('Удаление сообщения', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        let model = Object.assign({}, this.moduleGroups[indexes[0]])
                        let newStructure = model.structure.slice()
                        newStructure.splice(indexes[1], 1)
                        model.structure = newStructure
                        this.$store.dispatch('moduleGroups/saveModuleGroup', model)
                    }
                })
        },
        showModuleSelectBlock(index) {
            this.dialogModuleAdd = true
            this.moduleGroupIndex = index
        },
        editModuleGroup(index) {
            this.editModuleGroupIndex = index
            this.dialog = true
        },
        handleResize() {
            this.windowHeight = window.innerHeight
        }
    },
    created() {
        this.$store.dispatch('moduleGroups/loadModuleGroups', this.$route.params['pathMatch'])
        // this.$store.dispatch('modules/loadModules', this.$route.params['pathMatch'])
        this.$store.dispatch('modules/loadModuleMethods').then(response => {
            this.moduleMethodsLoaded = true
        })
        this.$store.dispatch('modules/changeBotIdModelDefault', +this.$route.params['pathMatch'])
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
        this.$store.dispatch('messages/messageAll', this.$route.params['pathMatch'])
        this.$store.dispatch('keyboards/loadKeyboards', this.$route.params['pathMatch'])
        this.$store.dispatch('clients/loadGroups', this.$route.params['pathMatch'])
        this.$store.dispatch('cards/cardListAll', this.$route.params['pathMatch'])
        this.$store.dispatch('secretClients/secretClientTaskAll', this.$route.params['pathMatch'])

        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    computed: {
        ...mapGetters({
            getModuleGroupById: 'moduleGroups/getModuleGroupById',
            modules: 'modules/modules',
            getModuleById: 'modules/getModuleById'
        }),
        moduleGroups: {
            get () {
                return this.$store.state.moduleGroups.moduleGroups
            },
            set(value) {
                this.$store.commit('moduleGroups/setModuleGroups', value)
            }
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
